/**
 * A link from a HELM page (A7Y-5210): a page of this app opens in place, with
 * the router, instead of in a new tab; anything else (a Gmail thread, a Slack
 * message, a Linear ticket, a Drive note) opens in a new tab as before.
 */
import type { ReactNode } from 'react';
import { Link, useInRouterContext } from 'react-router-dom';
import { inAppPath } from './inAppPath';

export function HelmLink({
  href,
  className,
  children,
  'data-testid': testId,
}: {
  href: string;
  className?: string;
  children: ReactNode;
  'data-testid'?: string;
}) {
  const inRouter = useInRouterContext();
  const path = inAppPath(href);
  if (path !== null && !inRouter) {
    // A section rendered on its own (its tests) has no router: same page, plain link.
    return (
      <a href={path} className={className} data-testid={testId}>
        {children}
      </a>
    );
  }
  if (path !== null) {
    return (
      <Link to={path} className={className} data-testid={testId}>
        {children}
      </Link>
    );
  }
  return (
    <a href={href} target="_blank" rel="noreferrer" className={className} data-testid={testId}>
      {children}
    </a>
  );
}
